import ResponseModals from "../Common/Modals/components/ResponseModals";
import useModalHandler from "../Common/Modals/hooks/useModalHandler";
import { setModalHandlerInstance } from "../Common/Modals/hooks/useModalSingleton";

import HeaderContainer from "./components/containers/HeaderContainer";
import LowerContainer from "./components/containers/LowerContainer";
import UpperContainer from "./components/containers/UpperContainer";
import SettlementExportModal from "./components/export/SettlementExportModal";
import SettlementNotesSection from "./components/notes/SettlementNotesSection";
import useFetchCaseDetails from "./hooks/useFetchCaseDetails";
import useSettlementExportModal from "./hooks/useSettlementExportModal";
import useSettlementPdfExport from "./hooks/useSettlementPdfExport";
import useSettlementPrintData from "./hooks/useSettlementPrintData";

export default function Settlement() {
  const handlers = useModalHandler();
  setModalHandlerInstance(handlers);
  useFetchCaseDetails();
  const settlementDocumentData = useSettlementPrintData();
  const availableSections = {
    financialSummary:
      settlementDocumentData.hasTotalMedicalReductionSection ||
      settlementDocumentData.hasFeeScheduleSection,
    medicalBreakdown: settlementDocumentData.hasMedicalBreakdownSection,
    settlementStatement: settlementDocumentData.hasSettlementStatementSection,
  };
  const { handleDownloadPdf, isDownloadReady } = useSettlementPdfExport(
    settlementDocumentData
  );
  const {
    isOpen,
    selectedSections,
    sectionOptions,
    hasSelectedSections,
    handleOpenModal,
    handleCloseModal,
    handleToggleSection,
  } = useSettlementExportModal(availableSections);

  const handleExportPdf = async () => {
    handleCloseModal();
    await handleDownloadPdf(selectedSections);
  };

  return (
    <div className="settlement-screen-only flex h-full w-full flex-col items-start justify-start gap-6 p-6 pt-0">
      <HeaderContainer
        onDownloadPdf={handleOpenModal}
        disableDownloadPdf={!isDownloadReady}
      />
      <SettlementNotesSection />
      <UpperContainer />
      <LowerContainer />
      <SettlementExportModal
        open={isOpen}
        onClose={handleCloseModal}
        onExport={handleExportPdf}
        onToggleSection={handleToggleSection}
        selectedSections={selectedSections}
        sectionOptions={sectionOptions}
        disableExport={!hasSelectedSections || !isDownloadReady}
      />
      <ResponseModals {...handlers} />
    </div>
  );
}
